import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
export function GuaranteeSection() {
  return <Section className="border-y border-white/5 bg-ink-900" data-id="element-94" data-mp="4vjoa88mncgq">
      <Reveal data-id="element-95" data-mp="9u3925bhii7i">
        <div className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-brand/20 bg-ink-850 p-8 text-center sm:p-10" data-id="element-96" data-mp="9tl6kqy8b7r5">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-soft" data-id="element-97" data-mp="er36xsy6kenj">
            <ShieldCheckIcon className="h-7 w-7 text-brand" data-id="element-98" data-mp="jqpsqqs2r37y" />
          </span>
          <h2 className="mt-5 font-display text-xl font-bold tracking-tight text-white sm:text-2xl" data-id="element-99" data-mp="nsb4g8svhbgk">
            Garantía 30 días — sin preguntas
          </h2>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-gray-400 sm:text-base" data-id="element-100" data-mp="xk72jjuyl1ks">
            Accedé al ebook, probá las estrategias, usá los bonos. Si sentís que
            no es para vos, te devolvemos el 100%.
          </p>
        </div>
      </Reveal>
    </Section>;
}